import styles from 'css/src/components/common/video-preview/FullscreenToggle.module.scss';

import React, { useCallback } from 'react';

import Tooltip from 'js/src/components/common/ui/Tooltip';

type FullscreenToggleProps = {
    isFullscreen: boolean;
    toggleFullscreen: () => void;
    tooltipTitle?: string;
};

const FullscreenToggle = React.memo(function FullscreenToggle({
    isFullscreen,
    toggleFullscreen,
    tooltipTitle,
}: FullscreenToggleProps) {
    const onClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            e.stopPropagation();

            toggleFullscreen();
        },
        [toggleFullscreen],
    );

    const icon = isFullscreen ? 'fullscreen_exit' : 'fullscreen';
    const anchor = (
        <a href="#" onClick={onClick} aria-label={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}>
            <i className="material-symbols-outlined">{icon}</i>
        </a>
    );
    return (
        <div className={styles['fullscreen-toggle']}>
            {tooltipTitle ? <Tooltip title={tooltipTitle}>{anchor}</Tooltip> : anchor}
        </div>
    );
});

export default FullscreenToggle;
